import React, { useState } from 'react';
import './style.css';
import BannerImg from './img/articlelist.png';
import PopupRegister from '../Signup/PopupRegister';

function TopBanner({ featuredArticle,user }) {
	const [showModal, setShowModal] = useState(false);
	// If no featured article, show default banner
	if (!featuredArticle) {
		return (
			<div className='al-banner' style={{ backgroundImage: `url(${BannerImg})` }}>
				<div className='al-banner__overlay' />
				<div className='al-banner__content'>
					<p className='al-banner__eyebrow'>Insights</p>
					<h1 className='al-banner__title'>Inside Injuries Articles</h1>
					<p className='al-banner__subtitle'>
						Expert analysis and insights on sports injuries, performance, and betting strategies.
					</p>
				</div>
			</div>
		);
	}

	// Display featured article in banner
	const backgroundImage = featuredArticle.thumbnail || BannerImg;
	
	return (
		<div className='al-banner' style={{ backgroundImage: `url(${backgroundImage})` }}>
			<PopupRegister showModal={showModal} setShowModal={setShowModal} />
			<div className='al-banner__overlay' />
			<div className='al-banner__content'>
				<p className='al-banner__eyebrow'>Featured Article</p>
				<h1 className='al-banner__title'>{featuredArticle.title}</h1>
				<p className='al-banner__subtitle'>
					{featuredArticle.meta_desc || 'Read more about this featured article...'}
				</p>
				<a href={`/article/${featuredArticle.slug}`} className='al-button al-button--cta' onClick={(e) => { if (!user?.login) { e.preventDefault(); setShowModal(true) } }}>
					{user?.login ? 'Read More' : 'Login or Free Sign Up to Read More'}
				</a>
			</div>
		</div>
	);
}

export default TopBanner;


